module.exports = __webpack_public_path__ + "img/JK.50b95764.png";